import { ToolRoute } from '../constants/routes';

export const Features = {
  AUDIO_TRANSCRIPTION: 'AUDIO_TRANSCRIPTION',
  TEXT_TRANSFORM: 'TEXT_TRANSFORM',
  QA_ASSIST: 'QA_ASSIST',
  FORM_FILLER: 'FORM_FILLER',
} as const;

export type FeatureName = typeof Features[keyof typeof Features];

export const toFeatureName = (value: unknown): FeatureName | undefined => {
  if (typeof value !== 'string') return undefined;
  const upper = value.toUpperCase();
  return (Object.values(Features) as string[]).includes(upper) ? (upper as FeatureName) : undefined;
};

export const ROUTE_FEATURE_MAP: Record<string, FeatureName> = {
  [ToolRoute.AUDIO_TRANSCRIPTION]: Features.AUDIO_TRANSCRIPTION,
  [ToolRoute.TEXT_TRANSFORM]: Features.TEXT_TRANSFORM,
  [ToolRoute.QA_ASSIST]: Features.QA_ASSIST,
  [ToolRoute.FORM_FILLER]: Features.FORM_FILLER,
};


